import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "../../../store";

export const selectAccess = createSelector(
  (state: AppState) => state.auth.access,
  (accessToken) => accessToken
);
